export default "__VITE_ASSET__DbuAXbtx__"